import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import React, { useState, useRef, useLayoutEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import moment from "moment";
import numeral, { options } from "numeral";
import "assets/css/grid_table.css";
import { getDataApi, saveApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";

const PollDataArchives = () => {
  let emptyRow = {
    archive_id: "",
    archive_date: "",
    table_name: "",
    no_of_rows_archived: "",
    base_dir_name: "",
    sub_dir_name: "",
    file_name: "",
    restored_date: "",
    no_of_rows_restored: "",
    comments: "",
    remote_ip_address: "",
    remote_user_name: "",
    remote_dir_name: "",
    remote_transfer_date: "",
    remote_file_size_bytes: "",
    remote_file_size_mb: "",
    local_file_size_bytes: "",
    local_file_size_mb: "",
    local_file_delete_date: "",
    hist_tbl_rows_deleted: "",
    hist_tbl_rows_delete_date: "",
    created_by: "",
    creation_date: "",
    last_updated_by: "",
    last_update_date: "",
  };

  /**** 31-May-2024 Velmani P. Following changes are made to template
   * 	a. Use a generic name "row" instead of "product".  Following are the name changed from template
   * 	   a1. products ==> rows
   * 		[products, setProducts] ==> [products, setRows]
   * 		[deleteProductsDialog, setDeleteProductsDialog] ==> [deleteRowsDialog, setDeleteRowsDialog]
   * 		[selectedProducts, setSelectedProducts] ==> [selectedRows, setSelectedRows]
   * 	   a2. product  ==> row
   *		[productDialog, setProductDialog] ==> [productDialog, setRowDialog]
   *		[deleteProductDialog, setDeleteProductDialog] ==> [deleteRowDialog, setDeleteRowDialog]
   *		[product, setProduct] ==> [product, setRow]
   * ******/
  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [editingRow, setEditingRow] = useState(null);
  const [tempValue,setTempValue] = useState({})
  const toast = useRef(null);
  const dt = useRef(null);
  const fetchStarted = useRef(false);

  // Fetch Machines when the component mounts
    const fetchRows = async () => {
      try {
        setIsLoading(true);
        const response = await getDataApi("/api/setup/pollDataArchive/selRows");
        console.log("Fetched machines:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
              toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            const errorInfo = response.data[2];

            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching machines:", error);
      }
      }
    };
  useLayoutEffect(() => {
    if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
    }
  }, []);

  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };

  /***
        const formatDateFields = (row, isNew) => {
            const formatDate = (date) => date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : null;
    
            return {
                ...row,
                creation_date: isNew ? formatDate(new Date()) : formatDate(row.creation_date),
                last_update_date: formatDate(new Date()),
                start_date: formatDate(row.start_date),
                end_date: formatDate(row.end_date)
            };
        };
         */

  const saveRow = async () => {
    setSubmitted(true);

    if (row.table_name.trim()) {
      //      const isNew = !row.machine_id;
      //     const formattedRow = formatDateFields(row, isNew);

      let _rows = [...rows];
      let _row = { ...row };

      try {
        if (row.archive_id) {
          /*** Update Row */
          const response = await saveApi(
            row,
            "/api/setup/pollDataArchive/updRow"
          );
          //await axios.put(`http://localhost:5000/api/machines/${row.machine_id}`, formattedRow);
          //             const updatedRows = rows.map((p) => (p.machine_id === row.machine_id ? formattedRow : p));
          //             setRows(updatedRows);

          let successFlag = response.data[0];
          if (successFlag === "Y") {
            const index = findIndexById(row.archive_id);
            // _rows[index] = { ..._rows[index], comments: _row.comments };
            _rows[index] = _row;

            // setRow(_row);
            // setRows(_rows);
            console.log("_row", _row);
            console.log("_rows", _rows);
            console.log("row", row);
            console.log("State Re-rendered");
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Comments Updated",
              life: 3000,
            });
          } else {
            let err_msg = response.data[1];
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Poll Data Archives Not Updated",
              life: 3000,
            });
          }
        }
        setRows(_rows);
        setRowDialog(false);
        setRow(emptyRow);
      } catch (error) {
        console.error("Error saving machine:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Poll Data Archives Save Failed",
          life: 3000,
        });
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill in the comment field",
        life: 3000,
      });
    }
  };

  const editRow = (row) => {
    setRow({ ...row });
    setRowDialog(true);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].archive_id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };
 

  /***
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const headerDontUse = (
        <div className="table-header">
            <h5 className="p-m-0">Manage Machines</h5>
            {/* <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span> * /}
        </div>
    );
    */
  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Legacy Poll Data Archives</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );

  const getLoadedHeaderContents = () => {
                    return (
                      <React.Fragment>
                        <div className="header-container">
                          <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                          Legacy Poll Data Archives
                          </h2>
                          <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                            <div className="header-container p-1">
                                <style>
                                {`
                                  input::placeholder {
                                    font-size: 17px; 
                                  }
                                `}
                              </style>
                            <span className="p-input-icon-right w-full md:w-auto"> 
                          <InputText
                            type="search"
                            onInput={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Search..."
                            className="w-full lg:w-auto text-sm p-3"
                            style={{ fontSize: '17px' }} 
                          />
                        </span>
                            </div>
                          </h2>
                        </div>
                      </React.Fragment>
                    );
                  }

  const archivedateTemplate = (rowData) => {
    return rowData.archive_date ? moment.utc(rowData.archive_date).format("YYYY-MM-DD") : null;
  };

  const localdateTemplate = (rowData) => {
    return rowData.local_file_delete_date ? moment.utc(rowData.local_file_delete_date).format("YYYY-MM-DD HH:mm:ss") : null;
    
  };

  const restoreddateTemplate = (rowData) => {
    return rowData.restored_date ? moment.utc(rowData.restored_date).format("YYYY-MM-DD HH:mm:ss") : null;
  };

  const transferdateTemplate = (rowData) => {
    return rowData.remote_transfer_date ? moment.utc(rowData.remote_transfer_date).format("YYYY-MM-DD HH:mm:ss") : null;
  };
  const rowhisttblDateTemplate = (rowData) => {
    return rowData.hist_tbl_rows_delete_date ? moment.utc(rowData.hist_tbl_rows_delete_date).format("YYYY-MM-DD HH:mm:ss") : null;
  };

  const rowArchiveTemplate = (rowData) => {
    return numeral(rowData.no_of_rows_archived).format("0,0");
  };

  const remotefileTemplate = (rowData) => {
    return numeral(rowData.remote_file_size_mb).format("0,0");
  };

  const localfileTemplate = (rowData) => {
    return numeral(rowData.local_file_size_mb).format("0,0");
  };
  const rowrestoredTemplate = (rowData) => {
    return numeral(rowData.no_of_rows_restored).format("0,0");
  };

  const formattedDate = row.archive_date ? moment.utc(row.archive_date).format("DD-MM-YYYY") : null;
  const localDate = row.local_file_delete_date ? moment.utc(row.local_file_delete_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const restoredDate = row.restored_date ? moment.utc(row.restored_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const transferDate = row.remote_transfer_date ? moment.utc(row.remote_transfer_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const rowhisttblDate = row.hist_tbl_rows_delete_date ? moment.utc(row.hist_tbl_rows_delete_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const rowArchiveNumber = numeral(row.no_of_rows_archived).format("0,0");
  const remotefileNumber = numeral(row.remote_file_size_mb).format("0,0");
  const localfileNumber = numeral(row.local_file_size_mb).format("0,0");
  const rowrestoredNumber = numeral(row.no_of_rows_restored).format("0,0");


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const updateBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-primary p-mr-2"
          onClick={() => editRow(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

   const CardComponent = ({title, data}) => {
        const rightAlignedLabels = ["No. of. Rows : ", "No of Rows Restored : ", "Production Line Number : ", "File Size(MB) : ",
          "Unix File Size(MB) : "
        ]
  
        return (
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> {title} </h5>
            <Divider className="my-2" />
            {data.map((item, index) => (
              <div key={index} className="label-value-pair">
                <span className="label">{item.label}</span>
                
                {item.label &&
                <span         
                className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                  {item.value}</span>
                }
                
              </div>
            ))}
          </Card>
        )
      }
      const inputBoxStyle = {
        backgroundColor:"rgb(235, 235, 235)",
        padding: "6px 10px",
        borderRadius: "4px",
        display: "block",
        wordWrap: "break-word",
        overflowWrap: "break-word",
        flexGrow: 1,
        minWidth: 0,
      }

  const onSaveEdit = async (rowData) => {
    try {
      const response =  await saveApi(rowData, "/api/setup/pollDataArchive/updRow");
      console.log("Response: ",response);
      let successFlag = response.data[0];
      if(successFlag === "Y") {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.archive_id === rowData.archive_id ? rowData : row  
          )
        )
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Comment updated successfully",
          life: 3000,
        })
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Comment not updated",
          life: 3000,
        })  
      }
    } catch (err) {
      console.err("Error updating comments: ",err);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Comment update failed",
        life: 3000,
      })  
    }
    setEditingRow(null);
    setTempValue((prev) => ({
      ...prev,
      [rowData.archive_id]:undefined
    }))
  }
   
  const oncancelEdit = (rowData) => {
    setTempValue((prev) => ({
      ...prev,
      [rowData.archive_id]:undefined
    }))
    setEditingRow(null);
  }

  const commentsEditor = (options) => {
    const {rowData} = options;
    return (
      <div className="flex align-items-center gap-2">
        <InputText
          value={tempValue[rowData.archive_id] ?? rowData.comments}
          onChange={(e) => setTempValue((prev) => ({
            ...prev,
            [rowData.archive_id]: e.target.value
          }))}
          autoFocus
        />
        <Button icon="pi pi-check" className="p-button-success p-button-sm" onClick={() => {rowData.comments = tempValue[rowData.archive_id] ?? rowData.comments;
          onSaveEdit(rowData); }}/>
        <Button icon="pi pi-times" className="p-button-danger p-button-sm" onClick={() => oncancelEdit(rowData)} />
      </div>
    )
  }
  const onCellEditComplete = (event) => {
    const {rowData,newValue,field} = event;
    setEditingRow(null);
    setTempValue((prev) => ({
      ...prev,
      [rowData.archive_id]:undefined
    }))
  }
  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
        {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
        {!isLoading && (
          <div className="card mb-3">
            {/* <div className="text-3xl text-800 font-bold mb-4">Legacy Poll Data Archives</div> */}
            <DataTable
              ref={dt}
              value={rows}
              scrollable
              scrollHeight="flex"
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              dataKey="archive_id"
              className="custom-datatable-border"
              tableStyle={{ minWidth: "50rem" }}
              sortField="archive_date"
              sortOrder={-1}
              paginator
              rows={pecaPageRows}
              rowsPerPageOptions={pecaRowsPerPageOptions}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
              globalFilter={globalFilter}
              header={header}
              emptyMessage="No Archives data found"
              stripedRows
              showGridlines
              editMode="cell"
              onCellEditInit={(e) => setEditingRow(e.rowIndex)}
              onCellEditCancel={() => setEditingRow(null)}
            >
              <Column
                body={readBodyTemplate}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column>
              {/* <Column
                body={updateBodyTemplate}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column> */}
              <Column
                field="archive_id"
                header="id"
                sortable="false"
                hidden="true"
                exportable={false}
              ></Column>
              <Column
                field="archive_date"
                header="Poll Date"
                body={archivedateTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>

              <Column
                field="table_name"
                header="Poll Table Name"
                sortable
                style={{
                  whiteSpace: "nowrap",
                }}
              ></Column>
              <Column
                field="no_of_rows_archived"
                header="No of Rows"
                body={rowArchiveTemplate}
                sortable
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "right",
                }}
              ></Column>
              <Column
                field="sub_dir_name"
                header="Ora Sub Dir"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="base_dir_name"
                header="Unix Dir"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="file_name"
                header="File Name"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="restored_date"
                header="Data Restored On"
                body={
                  restoreddateTemplate
                }
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="no_of_rows_restored"
                header="No of Rows restored"
                body={
                   rowrestoredTemplate
                }
                sortable
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "right",
                }}
              ></Column>
              <Column
                field="comments"
                header="Comments"
                editor = {(options) => commentsEditor(options)}
                onCellEditComplete={onCellEditComplete}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="remote_ip_address"
                header="Remote Server"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="remote_user_name"
                header="Remote User"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="remote_dir_name"
                header="Directory"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="remote_transfer_date"
                header="Remote ftp date"
                sortable
                body={
                 transferdateTemplate
                }
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="remote_file_size_mb"
                header="File Size(MB)"
                body={remotefileTemplate}
                sortable
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "right",
                }}
              ></Column>
              <Column
                field="local_file_size_mb"
                header="Unix File Size(MB)"
                body={localfileTemplate}
                sortable
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "right",
                }}
              ></Column>
              <Column
                field="local_file_delete_date"
                header="Archive Date"
                body={localdateTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="hist_tbl_rows_deleted"
                header="Hist Tbl Rows Deleted"
                // body={localdateTemplate}
                // {restoredDate === "Invalid date" ? "" : localdateTemplate}
                sortable
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "right",
                }}
              ></Column>
              <Column
                field="hist_tbl_rows_delete_date"
                header="Hist Tbl Rows Delete Date "
                body={rowhisttblDateTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
            </DataTable>
          </div>
        )}

       
        <Dialog
          visible={rowDialog}
          style={{ width: "1400px" }}
          modal
          className="p-fluid"
          onHide={hideDialog}
        >
                <h4 style={{"fontWeight":"bold"}}> Legacy Poll Data Archives </h4>
                        <Divider className="my-4" />
                        <h5 style={{"fontWeight":"bold"}}> Update Legacy Poll Data Archives </h5>
                        <Divider className="my-4" />
                        <p style={{color: "red", fontWeight: "bold"}}>
                          Note : Only Comments can be updated.
                        </p>
                        <div className="card-wrapper">
                          <CardComponent
                            title="Archive Info"
                            data={[
                              {label:"Poll Date : ", value: formattedDate },
                              {label:"Poll Table Name : ", value: row.table_name },
                              {label:"No. of. Rows : ", value: rowArchiveNumber },
                              {label:"Ora Sub Dir : ", value: row.sub_dir_name },
                              {label:"Unix Dir", value: row.base_dir_name },
                              {label:"File Name", value: row.file_name },
                            ]}
                          />
                        <Card className="card-containers">
                                      <h5  style={{"fontWeight":"bold"}}> Restore Info </h5>
                                      <Divider className="my-2" />
                                      <div className="label-value-pair">
                                      <span className="label" htmlFor="start_date">Data Restored On : </span>
                                      <span         
                                       className="value-box">
                                      {restoredDate}</span>
                                    </div>
                                    <div className="label-value-pair">
                                      <span className="label" htmlFor="end_date">No of Rows Restored : </span>
                                      <span         
                                       className="value-box">
                                      {rowrestoredNumber}</span>
                                    </div>
                                    <div className="label-value-pair">
                                      <span className="label" htmlFor="end_date">Comments : </span>
                                      <span style={{flexGrow:1}}>
                                      <InputText
                                        id="comments"
                                        value={row.comments}
                                        onChange={(e) => onInputChange(e, "comments")}
                                        required
                                        rows={3}
                                        cols={20}
                                        autoFocus
                                        className={classNames({
                                          "p-invalid": submitted && !row.comments,
                                        })}
                                        style={inputBoxStyle}
                                      />
                                      {submitted && !row.comments && (
                                        <small className="p-error">Comments is required.</small>
                                      )}
                                      </span>
                                    </div>
                                    </Card>
                          <CardComponent
                            title="Remote Server Info"
                            data={[
                              {label:"Remote Server : ", value: row.remote_ip_address },
                              {label:"Remote User : ", value: row.remote_user_name },
                              {label:"Directory : ", value: row.remote_dir_name },
                              {label:"Remote ftp date", value: transferDate },
                              {label:"File Size(MB) : ", value: remotefileNumber },
                            ]}
                          />
                         <CardComponent
                            title="Remote Server Info"
                            data={[
                              {label:"Unix File Size(MB) : ", value: localfileNumber },
                              {label:"Archive Date : ", value: localDate },
                            ]}
                          />
                          <CardComponent
                            title="Hist Table Info"
                            data={[
                              {label:"Hist Tbl Rows Deleted : ", value: row.hist_tbl_rows_deleted },
                              {label:"Hist Tbl Rows Delete Date : ", value: rowhisttblDate },
                            ]}
                          />
                         </div>                
              
         <div className="btn-container">
                   <Button
                     label="Cancel"
                     icon="pi pi-times"
                     className="p-button-text"
                     onClick={hideDialog}
                     style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
                   />
                   <Button
                     label="Save"
                     icon="pi pi-check"
                     className="p-button-text"
                     onClick={saveRow}
                     style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
                   />
                   </div>
        </Dialog>
       <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                        <h4 style={{"fontWeight":"bold"}}> Legacy Poll Data Archives </h4>
                        <Divider className="my-4" />
                        <h5 style={{"fontWeight":"bold"}}> View Legacy Poll Data Archives </h5>
                        <Divider className="my-4" />
                        <div className="card-wrapper">
                          <CardComponent
                            title="Archive Info"
                            data={[
                              {label:"Poll Date : ", value: formattedDate },
                              {label:"Poll Table Name : ", value: row.table_name },
                              {label:"No. of. Rows : ", value: rowArchiveNumber },
                              {label:"Ora Sub Dir : ", value: row.sub_dir_name },
                              {label:"Unix Dir", value: row.base_dir_name },
                              {label:"File Name", value: row.file_name },
                            ]}
                          />
                          <CardComponent
                            title="Restore Info"
                            data={[
                              {label:"Data Restored On : ", value: restoredDate },
                              {label:"No of Rows Restored : ", value: rowrestoredNumber },
                              {label:"Comments : ", value: row.comments },
                            ]}
                          />
                          <CardComponent
                            title="Remote Server Info"
                            data={[
                              {label:"Remote Server : ", value: row.remote_ip_address },
                              {label:"Remote User : ", value: row.remote_user_name },
                              {label:"Directory : ", value: row.remote_dir_name },
                              {label:"Remote ftp date", value: transferDate },
                              {label:"File Size(MB) : ", value: remotefileNumber },
                            ]}
                          />
                         <CardComponent
                            title="Remote Server Info"
                            data={[
                              {label:"Unix File Size(MB) : ", value: localfileNumber },
                              {label:"Archive Date : ", value: localDate },
                            ]}
                          />
                          <CardComponent
                            title="Hist Table Info"
                            data={[
                              {label:"Hist Tbl Rows Deleted : ", value: row.hist_tbl_rows_deleted },
                              {label:"Hist Tbl Rows Delete Date : ", value: rowhisttblDate },
                            ]}
                          />
                         </div>
                    </Dialog>
                    <Dialog 
                        header="API Error" 
                        visible={errorDialogVisible} 
                        style={{ width: '400px' }} 
                        onHide={hideDialog} 
                        footer={
                            <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                        }
                    >    
                     <p>
        
                            {errorMessage}
                        </p>
                    </Dialog>
                    <style jsx>{`
                      .card-wrapper {
                        display: grid;
                        grid-template-columns: repeat(3,1fr);
                        gap: 10px;
                        padding: 5px;
                      }
        
                      .card-containers {
                        display: flex;
                        background-color: #f9f9f9;
                        flex-direction: column;
                        justify-content: flex-start;
                        border: 1px solid #ccc;
                        paddig: 10px;
                        box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                        height: auto;
                        width: 100%;
                      }
        
                      .label-value-pair {
                        display: flex;
                        flex-direction: row,
                        align-items: flex-start;
                        gap: 5px;
                        margin-bottom: 8px;
                        flex-wrap: wrap;
                      }
        
                      .label {
                        font-weight: bold;
                        white-space: nowrap;
                      }
        
                      .value-box {
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }
        
                      .align-right {
                        text-align: right;
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }
                      
                      .btn-container {
                      display: flex;
                      justify-content: center;
                      gap:20px;
                      margin-top:20px;
                      }
                    `}
                    </style>
                    </div>
    </div>
  );
};

export default PollDataArchives;
